<div class="order-dynamic-forms-container " *ngIf="selectedOrder; else noSelectedOrder">
    <div class="order-dynamic-form-item {{selectedOrder?.status?.code}}"
         [ngClass]="{'event-form-half-width': formConfig?.formHalfWidth}"
         [ngStyle]="{'width': formConfig?.formWidth}"
         *ngFor="let formConfig of _orderFormConfigs; let i = index">
      <span class="top-panel titles">{{formConfig.title}}</span>
      <gen-dynamic-form
              class="info-dynamic-form"
              [popupMode]="false"
              [formName]="formConfig?.formId"
              [editMode]="true"
              (validateChange)="isFormValid = $event"
              [formVertical]="true"
              [disabled]="!canUserWrite()"
              [disabledForced]="!canUserWrite()"
              [listenToDataChange]="true"
              [requiredMessage]="''"
              (formChange)="updateFormData($event, i)"
              [ngClass] = "(hasUpdatedFields || displayFooter)? 'footer-show':'footer-close'"
      ></gen-dynamic-form>
    </div>

    <div class="floating-action-bar"
      [ngStyle]="{
        'position': hasUpdatedFields && isFormValid && displayFooter ? 'static' : 'absolute',
        'padding.em':  hasUpdatedFields && isFormValid ? '0.8' : '0'}"
    >
      <gen-button id="saveOrderContentBtn" class="save-button"
                  *ngIf="hasUpdatedFields && isFormValid"
                  [ngClass]=""
                  (click)="saveOrderContent()"
                  [type]="'primary'"
                  [text]="'Save'"
                  genTooltip
                  [tooltipPosition]="'BOTTOM'" [appendToBody]="true"
                  [iconClass]="">
      </gen-button>
    </div>

  </div>

  <ng-template #noSelectedOrder>
      <div class="no-data-text">
          No Data Available
      </div>
  </ng-template>
